import React from "react";
import { Box, Typography } from "@mui/material";

const ConflictsSummary = ({ totalConflicts, hasUnresolvedConflicts }) => (
  <Box mb={2}>
    <Typography variant="body1" gutterBottom>
      Found <strong>{totalConflicts}</strong> potential conflict{totalConflicts !== 1 ? "s" : ""}.
      {hasUnresolvedConflicts && (
        <span style={{ color: "#d32f2f", marginLeft: "8px" }}>
          ⚠ Some conflicts need resolution
        </span>
      )}
    </Typography>
    <Typography variant="body2" color="textSecondary">
      Click on a field to select which value to keep. <strong>Top (light blue)</strong> = New OSM data,
      <strong> Bottom (light green)</strong> = Existing database record.
    </Typography>
  </Box>
);

export default ConflictsSummary;
